const base = require('instorepickup/checkout/shipping');
const { checkoutEventBus } = require('./events');
const addressHelpers = require('./address');
const bylFormHelpers = require('./formErrors');
const loader = require('../components/loader');
const formHelpers = require('../components/forms');
const modals = require('../components/modals');
const clientSideValidation = require('../components/clientSideValidation');
const checkoutStageConstants = require('./stage/constants');
const checkoutStageManager = require('./stage/manager');
const checkoutViewManager = require('./checkoutViewManager');
const cifHelpers = require('./cif');
const getAnalyticsEventBus = require('../common/getAnalyticsEventBus');
const formUtils = require('../common/utils/formUtils');
const {
  hideElementsBySelector,
  showElementsBySelector,
} = require('../common/utils/dom');
const storeLocator = require('../storeLocator/index');
const shippingMethodsConfig = require('../../../../config/shippingMethodsConfig.json');

const analyticsEventBus = getAnalyticsEventBus();
const { ANALYTICS_EVENTS } = require('../analytics/events');

const orderSummarySelector = '.order-summary';
const placeOrderBtnSelector = '.place-order';
const giftMessageFormSelector = '.checkout-gift';
const requestInvoiceTogglerSelector = '#requestInvoice';

function saveMultiShipInfo() {
  $('.btn-save-multi-ship').on('click', function handleSaveMultiShipClick(e) {
    e.preventDefault();

    // Save address to checkoutAddressBook
    const form = $(this).closest('form');
    const $rootEl = $(this).closest('.shipping-content');
    const data = $(form).serialize();
    const url = $(form).attr('action');

    const checkedShippingMethod = $(
      'input[name=dwfrm_shipping_shippingAddress_shippingMethodID]:checked',
      form
    );
    const isStorePickUpMethod = checkedShippingMethod.attr('data-pickup');
    const storeId = $("input[name='storeId']", form).val();
    const errorMsg =
      'Before you can continue to the next step, you must select a store.';

    if (isStorePickUpMethod === 'true' && storeId === undefined) {
      base.methods.createErrorNotification(errorMsg);
    } else {
      $rootEl.spinner().start();
      $.ajax({
        url,
        type: 'post',
        dataType: 'json',
        data,
      })
        .done((response) => {
          bylFormHelpers.clearPreviousErrors(form);
          if (response.error) {
            if (response.fieldErrors && response.fieldErrors.length) {
              response.fieldErrors.forEach((error) => {
                if (Object.keys(error).length) {
                  formUtils.loadFormErrors(form, error);
                }
              });
            } else if (response.serverErrors && response.serverErrors.length) {
              $.each(response.serverErrors, (index, element) => {
                base.methods.createErrorNotification(element);
              });
            }
          } else {
            // Update UI from response
            $('body').trigger('checkout:updateCheckoutView', {
              order: response.order,
              customer: response.customer,
            });

            base.methods.viewMultishipAddress($rootEl);
          }

          if (response.order && response.order.shippable) {
            $('button.submit-shipping').attr('disabled', null);
          }

          $rootEl.spinner().stop();
        })
        .fail((err) => {
          if (err.responseJSON.redirectUrl) {
            window.location.href = err.responseJSON.redirectUrl;
          }

          $rootEl.spinner().stop();
        });
    }
    return false;
  });
}

/**
 * Handle response from the server for valid or invalid form fields.
 * @param {Object} data - the response data with the invalid form fields or
 *  valid model data.
 */
function shippingFormResponse(data) {
  const formSelector = '.single-shipping form';

  // highlight fields with errors
  if (data.error) {
    if (data.fieldErrors?.length) {
      data.fieldErrors.forEach((error) => {
        if (Object.keys(error).length) {
          formUtils.loadFormErrors(formSelector, error);
        }
      });
      return;
    }

    if (data.serverErrors?.length) {
      $.each(data.serverErrors, (index, element) => {
        bylFormHelpers.addCheckoutError(element);
      });
      return;
    }

    if (data.cartError) {
      window.location.href = data.redirectUrl;
    }

    if (data.showModal) {
      modals.createCustomModal(
        data.modalHtml,
        { backdrop: 'static' },
        data.includeAssets
      );
      return;
    }

    // Undefined falls back to the technical error.
    bylFormHelpers.addCheckoutError(data.errorMessage);
  } else {
    bylFormHelpers.removeCheckoutError();

    // Populate the Address Summary
    $('body').trigger('checkout:updateCheckoutView', {
      order: data.order,
      customer: data.customer,
    });

    // Only a store pickup answers with a card.
    if (data.storeDetailsHtml) {
      updateStoreShippingSummaryInformation(
        data.shipmentUUID || data.order.shipping[0].UUID,
        data.storeDetailsHtml
      );
    }
  }
}

/**
 * Update list of available shipping methods whenever user modifies shipping address details.
 * @param {jQuery} $shippingForm - current shipping form
 */
function updateShippingMethodList($shippingForm) {
  // delay for autocomplete!
  setTimeout(() => {
    const $shippingMethodList = $shippingForm.find('.shipping-method-list');
    const urlParams =
      addressHelpers.methods.getAddressFieldsFromUI($shippingForm);
    const shipmentUUID = $shippingForm.find('[name=shipmentUUID]').val();
    const url = $shippingMethodList.data('actionUrl');
    urlParams.shipmentUUID = shipmentUUID;

    $.ajax({
      url,
      type: 'post',
      dataType: 'json',
      data: urlParams,
      success(data) {
        if (data.error) {
          window.location.href = data.redirectUrl;
        } else {
          $('body').trigger('checkout:updateCheckoutView', {
            order: data.order,
            customer: data.customer,
            options: { keepOpen: true },
          });
          $('body').trigger('checkout:updateShippingMethods-success');
        }
      },
    });
  }, 300);
}

/**
 * Handle billing block selection
 * @param {ShippingMethod} shippingMethod - Order Shipping Method Model
 */
function handleBillingSelection(shippingMethod) {
  copyEmailFieldToBilling(true);
  cifHelpers.methods.copyCifFieldsToBilling();

  const mustUseDifferentBilling =
    shippingMethod.storePickupEnabled || shippingMethod.dropPointEnabled;

  const useSameBilling = !mustUseDifferentBilling;
  if (useSameBilling) {
    const checkedShipping = $(
      '.shipment-selector-block .addressSelector input:checked'
    );
    const addressID = checkedShipping.attr('id').split('-')[1];
    const equivalentBillingInput = $(
      `.billing-address-block .addressSelector input[id$=${addressID}]`
    );
    equivalentBillingInput.prop('checked', true);
    equivalentBillingInput.trigger('change');

    // Billing form inside payment
    const billingBlock = $('.payment-form');
    billingBlock.attr(
      'data-address-mode',
      checkedShipping.val() === 'new' ? 'new' : 'shipment'
    );

    // Clear errors from billing form
    bylFormHelpers.clearPreviousErrors(billingBlock);

    // Shipping form
    const shippingAddressBlock = $('.shipping-form .shipping-address-block');
    const shippingFields = $(
      '[name*="_shippingAddress_"]',
      shippingAddressBlock
    );
    formHelpers.copyFormValuesToAnotherForm(
      shippingFields,
      billingBlock,
      'billing',
      true
    );
    const billingPhonePrefix = $('[name="phonePrefix"]', billingBlock);
    const shippingPhonePrefix = $('[name="phonePrefix"]', shippingAddressBlock);
    billingPhonePrefix.val(shippingPhonePrefix.val());

    // Update Billing summary
    const { updateBillingSummaryFromUI } = require('./billing/helpers').methods;
    updateBillingSummaryFromUI();
  }
}

function copyEmailFieldToBilling(copyIfFilled = false) {
  const $shippingEmailField = $('.shipping-address-block [name$="email"]');
  const $billingEmailField = $(
    '[name*="_billing_"][name$="email"]:not([data-autocomplete-form=off])'
  );

  if ((!copyIfFilled && $billingEmailField.val() === '') || copyIfFilled) {
    $billingEmailField.val($shippingEmailField.val());
  }
}

async function doSubmit($form, shippingFormData, continueButton) {
  return $.ajax({
    url: $form.attr('action'),
    type: 'post',
    data: shippingFormData,
    success(data) {
      loader.removeLoader(continueButton);
      shippingFormResponse(data);
      if (data.error) {
        checkoutStageManager.methods.setStage(
          checkoutStageConstants.SHIPPING_ADDRESS
        );
        if (
          data.fieldErrors &&
          data.fieldErrors.length > 0 &&
          $form.data('addressMode') !== 'new'
        ) {
          const selectedAddress = $('.address-option input:checked', $form);
          selectedAddress
            .closest('.address-option')
            .find('.btn-edit-address')
            .trigger('click');
        } else {
          showElementsBySelector('.submit-shipping-error');
        }

        $form.addClass('shipping-form--address-error');
      } else {
        $('body').trigger('checkout:shipment-saved', data.order);
        // Send info for Analytics
        analyticsEventBus.publish(
          analyticsEventBus.EVENTS.checkoutShippingInfoAdded,
          {
            order: data.order,
          }
        );

        $('body').trigger('checkout:updateCheckoutView', {
          order: data.order,
          customer: data.customer,
        });

        const currentStage = checkoutStageManager.methods.getStage();
        if (
          currentStage === checkoutStageConstants.SHIPPING_ADDRESS ||
          currentStage === checkoutStageConstants.SHIPPING_METHOD
        ) {
          checkoutStageManager.methods.setStage(
            checkoutStageConstants.SHIPPING_SUMMARY
          );
        }

        handleBillingSelection(data.order.shipping[0].selectedShippingMethod);
      }
      $form.removeClass('shipping-form--loading');
    },
    error(err) {
      loader.removeLoader(continueButton);
      $form.removeClass('shipping-form--loading');
      if (err.responseJSON && err.responseJSON.redirectUrl) {
        window.location.href = err.responseJSON.redirectUrl;
      }
    },
    complete() {
      checkoutViewManager.methods.changeViewToNormal();
    },
  });
}

/**
 * Submits the shipping form (In checkout.js in SFRA)
 * @param  {jQuery} form - Shipping form
 */
async function submitShipping($form) {
  let response;
  const form = $form[0];
  const continueButton = document.querySelector('.submit-shipping button');
  let shippingFormData = $form.serialize();

  const selectedStoreId = $('.pickup-in-store').data('selectedStoreId');
  const storeLocatorIsLoaded = $form.find('input[name="storeId"]').length > 0;
  if (selectedStoreId && !storeLocatorIsLoaded) {
    shippingFormData += `&storeId=${selectedStoreId}`;
  }

  bylFormHelpers.clearPreviousErrors(form);
  bylFormHelpers.removeCheckoutError();
  hideElementsBySelector('.submit-shipping-error');

  $('body').trigger('checkout:serializeShipping', {
    form,
    data: shippingFormData,
    callback(data) {
      shippingFormData = data;
    },
  });

  loader.addLoader(continueButton);
  $form.addClass('shipping-form--loading');

  const isFormatValid = clientSideValidation.functions.validateFormatData(form);
  if (isFormatValid) {
    response = await doSubmit($form, shippingFormData, continueButton);
  } else {
    loader.removeLoader(continueButton);
    $form.removeClass('shipping-form--loading');
    $form.addClass('shipping-form--address-error');
    showElementsBySelector('.submit-shipping-error');
    response = {
      error: true,
    };
  }

  return response;
}

/**
 * updates the shipping address form values within shipping forms
 * @param {Object} shipping - the shipping (shipment model) model
 */
function updateShippingAddressFormValues(shipping) {
  let addressObject = $.extend({}, shipping.shippingAddress);

  if (!addressObject) {
    addressObject = {
      title: null,
      firstName: null,
      lastName: null,
      address1: null,
      address2: null,
      city: null,
      postalCode: null,
      stateCode: null,
      countryCode: null,
      phone: null,
    };
  }

  addressObject.isGift = shipping.isGift;
  addressObject.giftMessage = shipping.giftMessage;

  $(`input[value=${shipping.UUID}]`).each((formIndex, el) => {
    const { form } = el;
    if (!form) return;
    const { countryCode } = addressObject;
    const shippingFormNameSelector = '[name*=_shipping_]';

    $(`input${shippingFormNameSelector}[name$=_firstName]`, form).val(
      addressObject.firstName
    );
    $(`input${shippingFormNameSelector}[name$=_lastName]`, form).val(
      addressObject.lastName
    );
    $(`input${shippingFormNameSelector}[name$=_address1]`, form).val(
      addressObject.address1
    );
    $(`input${shippingFormNameSelector}[name$=_address2]`, form).val(
      addressObject.address2
    );
    $(`input${shippingFormNameSelector}[name$=_city]`, form).val(
      addressObject.city
    );
    $(`input${shippingFormNameSelector}[name$=_postalCode]`, form).val(
      addressObject.postalCode
    );

    const stateSelect = $(
      `select${shippingFormNameSelector}[name$=_stateCode],input${shippingFormNameSelector}[name$=_stateCode]`,
      form
    );
    const stateSelectEnabledOptions = $('option:not([disabled])', stateSelect);

    if (stateSelectEnabledOptions.length === 1) {
      stateSelect.val(stateSelectEnabledOptions.attr('value'));
    } else {
      stateSelect.val(addressObject.stateCode);
    }

    const countrySelect = $(
      `select${shippingFormNameSelector}[name$=_country]`,
      form
    );
    const countrySelectEnabledOptions = $(
      'option:not([disabled])',
      countrySelect
    );

    if (countrySelectEnabledOptions.length === 1) {
      countrySelect.val(countrySelectEnabledOptions.attr('value'));
    } else if (countryCode && typeof countryCode === 'object') {
      countrySelect.val(addressObject.countryCode.value);
    } else {
      countrySelect.val(addressObject.countryCode);
    }

    $(`input${shippingFormNameSelector}[name$=_phone]`, form).val(
      addressObject.phoneBody ? addressObject.phoneBody : addressObject.phone
    );
    $(`select${shippingFormNameSelector}[name$=_phonePrefix]`, form).val(
      addressObject.phonePrefix ? addressObject.phonePrefix : ''
    );

    $(`input${shippingFormNameSelector}[name$=_isGift]`, form).prop(
      'checked',
      addressObject.isGift
    );
    $(`textarea${shippingFormNameSelector}[name$=_giftMessage]`, form).val(
      addressObject.isGift && addressObject.giftMessage
        ? addressObject.giftMessage
        : ''
    );

    if (
      shipping.selectedShippingMethod?.storePickupEnabled ||
      shipping.selectedShippingMethod?.dropPointEnabled
    ) {
      $(`input${shippingFormNameSelector}[name$=_title]`, form).val(
        addressObject.title
      );
    }
  });

  $('body').trigger('shipping:updateShippingAddressFormValues', { shipping });
}

/**
 * Clear out all the shipping form values and select the new address in the drop down
 * @param {Object} order - the order object
 */
function clearShippingForms(order) {
  order.shipping.forEach((shipping) => {
    const shippingInput = $(`input[value=${shipping.UUID}]`)[0];
    if (!shippingInput) return;
    const { form } = shippingInput;
    if (!form) return;

    $('#shippingTitledefault', form).val('');
    $('input[name$=_firstName]', form).val('');
    $('input[name$=_lastName]', form).val('');
    $('input[name$=_address1]', form).val('');
    $('input[name$=_address2]', form).val('');
    $('input[name$=_city]', form).val('');
    $('input[name$=_postalCode]', form).val('');

    const stateSelect = $(
      'select[name$=_stateCode],input[name$=_stateCode]',
      form
    );
    const stateSelectEnabledOptions = $('option:not([disabled])', stateSelect);
    if (stateSelectEnabledOptions.length > 1) {
      stateSelect.val('');
    }

    // $('select[name$=_country]', form).val(''); Do not clear country field to avoid front errors
    $('select[name$=_comunaCode]', form).val('');
    $('input[name$=_colonia]', form).val('');

    $('input[name$=_phone]', form).val('');

    $('input[name$=_isGift]', form).prop('checked', false);
    $('textarea[name$=_giftMessage]', form).val('');
    $(form).find('.gift-message').addClass('d-none');
  });
}

function setDefaultShippingAddress(data) {
  const shippingInput = $(`input[value=${data.order.shipping[0].UUID}]`)[0];
  const { form } = shippingInput;
  let matchingAddressInput = null;

  if (data.order.billing.matchingAddressId) {
    matchingAddressInput = $(
      `#shippingAddress-${data.order.billing.matchingAddressId}`
    );
    if (matchingAddressInput?.length > 0) {
      $(form).attr('data-address-mode', 'customer');
      matchingAddressInput.prop('checked', true).trigger('change');
    }
  } else if (data.customer.addresses && data.customer.addresses.length > 0) {
    matchingAddressInput = $(
      `#shippingAddress-${data.customer.addresses[0].ID}`
    );
    if (matchingAddressInput?.length > 0) {
      $(form).attr('data-address-mode', 'customer');
      matchingAddressInput.prop('checked', true).trigger('change');
    }
  } else {
    $(form).attr('data-address-mode', 'new');
    const addressSelectorDropDown = $(
      '.addressSelector input[value=new]',
      form
    );
    $(addressSelectorDropDown).prop('checked', true).trigger('change');
  }
}

/**
 * Does Ajax call to select shipping method
 * @param {string} url - string representation of endpoint URL
 * @param {Object} urlParams - url params
 */
function selectShippingMethodAjax(url, urlParams) {
  $('body').trigger('checkout:beforeShippingMethodSelected');
  $.ajax({
    url,
    type: 'post',
    dataType: 'json',
    data: urlParams,
  }).done((data) => {
    if (data.error) {
      window.location.href = data.redirectUrl;
    } else {
      clearShippingForms(data.order);
      setDefaultShippingAddress(data);
      $('body').trigger('checkout:updateCheckoutView', {
        order: data.order,
        customer: data.customer,
        options: { keepOpen: true },
        urlParams,
      });
    }
    $('body').trigger('checkout:shippingMethodSelected', data);
  });
}

/**
 * Updates shipping summary block title
 * depending on selected shipping method
 * @param {Object} shipping - the shipping (shipment model) model
 */
function updateShippingSummaryTitle(shippingMethod) {
  hideElementsBySelector('.shipping-summary__title');

  if (shippingMethod.dropPointEnabled) {
    showElementsBySelector('.shop-delivery__title-droppoint');
  } else if (shippingMethod.storePickupEnabled) {
    showElementsBySelector('.shop-delivery__title-store');
  } else {
    showElementsBySelector('.address-selected__title');
  }
}

/**
 * Shows the card of the store a shipment is picked up from, in its shipping
 * and order summaries.
 *
 * The card is the one SubmitShipping rendered, with the template and model of
 * the Stores-GetStoreById include the reloaded checkout shows. Copying it from
 * the store locator results instead showed what the search returned, not what
 * a reload shows, and nothing at all once the results left the page.
 * @param {string} shipmentUUID - UUID of the shipment
 * @param {string} storeDetailsHtml - the card, as the server rendered it
 */
function updateStoreShippingSummaryInformation(shipmentUUID, storeDetailsHtml) {
  $(`[data-shipment-summary=${shipmentUUID}]`).each((i, el) => {
    $(el).find('.store-summary-details').html(storeDetailsHtml);
    storeLocator.addListenersForToggleStoreOpeningTime(el);
  });
}

/**
 * updates the order summary for an order shipment model
 * @param {Object} order - the order object
 */
function updateGiftInformation(order) {
  const summaryGiftClass = '.order-summary-gift';
  const summaryGiftSelector = document.querySelector(summaryGiftClass);

  if (!summaryGiftSelector) return;

  if (order.bylIsGift) {
    if (summaryGiftSelector.querySelector('.gift-message-summary')) {
      summaryGiftSelector.querySelector('.gift-message-summary').innerText =
        order.bylGiftMessage || '';
    }
    showElementsBySelector(summaryGiftClass);
  } else {
    hideElementsBySelector(summaryGiftClass);
  }
}

function eventsGiftMessageSelect() {
  saveGiftInformation();
  removeGiftRequest();

  const editGiftSelector = document.querySelector('.gift-message-edit');

  // eslint-disable-next-line listeners/no-missing-remove-event-listener
  editGiftSelector?.addEventListener('click', showGiftMessageBlock);

  const backButtonGiftSelector = document.querySelector(
    '.checkout-gift .order-summary__back-button'
  );

  // eslint-disable-next-line listeners/no-missing-remove-event-listener
  backButtonGiftSelector?.addEventListener('click', hideGiftMessageBlock);
}

function hideGiftMessageBlock() {
  hideElementsBySelector(giftMessageFormSelector);

  showElementsBySelector(orderSummarySelector);
  showElementsBySelector(placeOrderBtnSelector);
  showElementsBySelector(requestInvoiceTogglerSelector);

  checkoutViewManager.methods.changeViewToNormal();
}

function showGiftMessageBlock() {
  showElementsBySelector(giftMessageFormSelector);

  hideElementsBySelector(orderSummarySelector);
  hideElementsBySelector(placeOrderBtnSelector);
  hideElementsBySelector(requestInvoiceTogglerSelector);

  checkoutViewManager.methods.changeViewToOnlyForm();
}

/**
 * Saves the gift message when is edited
 */
function saveGiftInformation() {
  const savedGiftSelector = document.querySelector('.checkout-gift-card__save');

  // eslint-disable-next-line listeners/no-missing-remove-event-listener, listeners/no-inline-function-event-listener
  savedGiftSelector?.addEventListener('click', (e) => {
    e.preventDefault();
    const form = savedGiftSelector.closest('form');
    const formData = formUtils.getFormData(form);
    const fieldTextarea = form.querySelector('.field-textarea');

    fetch(form.action, {
      method: form.method,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.error) {
          fieldTextarea.classList.add('field-textarea--is-invalid');
          fieldTextarea
            .querySelector('.field-textarea__error-message')
            .classList.add('transition-ap8--show');
        } else {
          hideGiftMessageBlock();
          updateGiftInformation({
            bylIsGift: true,
            bylGiftMessage: formData.message,
          });
        }
      })
      .catch(() => {});
  });
}

/**
 * Remove the gift request for the order
 */
function removeGiftRequest() {
  const removeGiftSelector = document.querySelector('.remove-gift-message');

  // eslint-disable-next-line listeners/no-missing-remove-event-listener, listeners/no-inline-function-event-listener
  removeGiftSelector?.addEventListener('click', (e) => {
    e.preventDefault();

    fetch(removeGiftSelector.dataset.url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        isGift: false,
      }),
    })
      .then((response) => response.json())
      .then(() => {
        hideGiftMessageBlock();
        updateGiftInformation({
          bylIsGift: false,
        });
      })
      .catch(() => {});
  });
}

/**
 * Show current shipping summary block,
 *  of a store or address
 * @param {boolean} isShopDelivery shop delivery method selected
 * @param {Object} customer customer model
 * @param {Integer} matchingAddressId address id
 */
function showCurrentShippingSummary(
  isShopDelivery,
  customer,
  matchingAddressId
) {
  const storeSummarySelector = '.store-summary-details';
  const addressSummarySelector = '.address-summary-details';
  const saveAddressSummarySelector = '.shipping-summary__save-address';

  if (isShopDelivery) {
    showElementsBySelector(storeSummarySelector);
    hideElementsBySelector(addressSummarySelector);
    hideElementsBySelector(saveAddressSummarySelector);
  } else {
    showElementsBySelector(addressSummarySelector);
    hideElementsBySelector(storeSummarySelector);

    // If registered, also show/hide the save address check depending on the selected method
    const shippingForm = document.querySelector('form.shipping-form');
    if (
      customer?.profile &&
      shippingForm?.dataset.addressMode === 'new' &&
      !matchingAddressId
    ) {
      showElementsBySelector(saveAddressSummarySelector);
    } else {
      hideElementsBySelector(saveAddressSummarySelector);
    }
  }
}

/**
 * Updates and shows shipping summary block
 * depending on selected shipping method
 * @param {Shipping} shipping - the shipping (shipment model) model
 * @param {Object} customer - the customer model
 */
function updateAndShowCurrentShippingSummaryBlock(shipping, customer) {
  const isShopDeliverySelected =
    shipping.selectedShippingMethod &&
    (shipping.selectedShippingMethod.dropPointEnabled ||
      shipping.selectedShippingMethod.storePickupEnabled);

  updateShippingSummaryTitle(shipping.selectedShippingMethod);
  showCurrentShippingSummary(
    isShopDeliverySelected,
    customer,
    shipping.matchingAddressId
  );
}

function updateShopDeliveryDataAttribute(isShopDeliverySelected) {
  const shippingForm = document.querySelector('.shipping-form');
  shippingForm?.setAttribute(
    'data-shop-delivery-selected',
    isShopDeliverySelected
  );
}

/**
 * Updates the shipping method promotions price after discount & promotion message
 * @param {Shipping} shipping - the shipping (shipment model) model
 */
function updateShippingMethodsPromotionInformation(shipping) {
  for (let i = 0; i < shipping.applicableShippingMethods.length; i++) {
    const shippingMethod = shipping.applicableShippingMethods[i];
    if (shippingMethod.promotions) {
      const shippingMethodBlockElement = document
        .querySelector(`.shipping-block__input[value=${shippingMethod.ID}]`)
        ?.closest('.shipping-block');
      const priceRowElement = shippingMethodBlockElement.querySelector(
        '.shipping-block__price-row'
      );
      const promoTextElement = shippingMethodBlockElement.querySelector(
        '.shipping-block__promo-text'
      );
      const selectedShippingMethodPriceElement =
        shippingMethodBlockElement.querySelector('.shipping-block__price');

      if (!priceRowElement || !selectedShippingMethodPriceElement) {
        return;
      }

      // Create discounted final price node
      const discountedPriceElement =
        selectedShippingMethodPriceElement.cloneNode(true);
      discountedPriceElement.innerHTML =
        shippingMethod.promotions.formattedFinalPrice;
      if (shippingMethod.promotions.floatFinalPrice === 0) {
        discountedPriceElement.classList.add('shipping-block__price--free');
      }

      // Make DOM modifications
      selectedShippingMethodPriceElement.classList.add(
        'shipping-block__price--old'
      );
      priceRowElement.append(discountedPriceElement);
      promoTextElement?.classList.remove('d-none');
    }
  }
}

/**
 * updates the shipping address selector with customer addresses
 * @param {Object} customer - the customer model
 */
function updateShippingAddressSelector(customer) {
  const form = $('.shipping-form');
  const $shippingAddressSelector = $('.addressSelector', form);
  if (!$shippingAddressSelector && $shippingAddressSelector.length < 1) return;

  if (customer.addresses && customer.addresses.length > 0) {
    customer.addresses.forEach((address) => {
      addressHelpers.methods.updateAddressOption({
        UUID: `ab_${address.ID}`,
        address,
      });
    });
  }
}

/**
 * Update shipping summary and order summary
 * @param {Shipping} shipping - the shipping (shipment model) model
 * @param {Order} order - the order model
 */
function updateShippingSummaryInformation(shipping, order) {
  $(`[data-shipment-summary=${shipping.UUID}]`).each((i, el) => {
    const container = el;
    const $container = $(el);
    const { selectedShippingMethod, shippingAddress } = shipping;
    const $addressContainer = $container.find('.address-summary');
    const $methodTitle = $container.find('.shipping-method-title');
    const $methodArrivalTime = $container.find('.shipping-method-arrival-time');
    const $methodPrice = $container.find('.shipping-method-price');
    const $shippingPhone = $container.find('.phone');
    const $shippingAddressLabel = $container.find('.shipping-addr-label');
    const $shippingSummaryLabel = $container.find('.shipping-method-label');
    const $summaryDetails = $container.find('.row.summary-details');

    addressHelpers.methods.populateAddressSummary(
      $addressContainer,
      shippingAddress
    );
    if (shippingAddress && shippingAddress.phone) {
      $shippingPhone.text(shippingAddress.phone);
    } else {
      $shippingPhone.empty();
    }

    if (selectedShippingMethod) {
      $('body').trigger('shipping:updateAddressLabelText', {
        selectedShippingMethod,
        resources: order.resources,
        shippingAddressLabel: $shippingAddressLabel,
      });
      $shippingSummaryLabel.show();
      $summaryDetails.show();
      $methodTitle.text(selectedShippingMethod.displayName);
      if (selectedShippingMethod.estimatedArrivalTime) {
        $methodArrivalTime.text(selectedShippingMethod.estimatedArrivalTime);
      } else {
        $methodArrivalTime.empty();
      }
      $methodPrice.text(selectedShippingMethod.shippingCost);
    }

    if (shippingAddress) {
      showElementsBySelector('.shipping-address-summary', container);
    } else {
      hideElementsBySelector('.shipping-address-summary', container);
    }
  });
}

/**
 * Update the shipping UI for a single shipping info (shipment model)
 * @param {Shipping} shipping - the shipping (shipment model) model
 * @param {Order} order - the order model
 * @param {Object} customer - the customer model
 */
function updateShippingInformation(shipping, order, customer) {
  base.methods.updateShippingMethods(shipping);
  updateShippingMethodsPromotionInformation(shipping);

  updateShippingAddressSelector(customer);

  const isShopDeliverySelected =
    shipping.selectedShippingMethod &&
    (shipping.selectedShippingMethod.dropPointEnabled ||
      shipping.selectedShippingMethod.storePickupEnabled);

  updateShopDeliveryDataAttribute(isShopDeliverySelected);

  updateShippingSummaryInformation(shipping, order);

  // Update Shipping Summaries (Shipping + Order)
  updateAndShowCurrentShippingSummaryBlock(shipping, customer);
  updateGiftInformation(order);
}

/**
 * Checks if the current selected shipping method is pickup
 * @returns {boolean} True if it is a pickup method, else false
 */
function isPickupMethodSelected() {
  const shippingForm = document.querySelector('form.shipping-form');
  const checkedShippingMethodInput = shippingForm.querySelector(
    '.shipping-method-list [type="radio"]:checked'
  );
  return checkedShippingMethodInput.dataset.pickup === 'true';
}

function selectShippingMethod() {
  $('.shipping-method-list').change(function onShippingMethodChange() {
    const $shippingForm = $(this).parents('form');
    const methodID = $(':checked', this).val();
    const shipmentUUID = $shippingForm.find('[name=shipmentUUID]').val();

    const urlParams = {};
    urlParams.shipmentUUID = shipmentUUID;
    urlParams.methodID = methodID;

    const url = $(this).data('select-shipping-method-url');

    selectShippingMethodAjax(url, urlParams);
  });
}

function updateShippingList() {
  // Empty function to override sfra function and avoid event listenter
}

const shippingAddressBlockSelector = '.shipping-address-block';
const shippingAddressSelectorSelector = '.shipment-selector-block';

/**
 * Show address block and hides address selector
 * @param {jQuery} shippingForm  - current shipping form
 */
function showOnlyAddressBlock(shippingForm) {
  hideElementsBySelector(shippingAddressSelectorSelector, shippingForm[0]);
  showElementsBySelector(shippingAddressBlockSelector, shippingForm[0]);
}

/**
 * Show address selector and hides address block
 * @param {jQuery} shippingForm  - current shipping form
 */
function showOnlyAddressSelector(shippingForm) {
  hideElementsBySelector(shippingAddressBlockSelector, shippingForm[0]);
  showElementsBySelector(shippingAddressSelectorSelector, shippingForm[0]);
}

/**
 * Hides both address selector and address block
 * @param {jQuery} shippingForm  - current shipping form
 */
function hideAddressSelectorAndBlock(shippingForm) {
  hideElementsBySelector(shippingAddressBlockSelector, shippingForm[0]);
  hideElementsBySelector(shippingAddressSelectorSelector, shippingForm[0]);
}

function selectNewAddress($shippingForm) {
  const $newEl = $shippingForm.find('.addressSelector input[value=new]');
  $newEl.prop('checked', true).trigger('change');
  this.showOnlyAddressBlock($shippingForm);
  checkoutViewManager.methods.changeViewToOnlyForm();
}

/**
 * Subscribe to checkout events related to shipping
 */
function subscribeToEvents() {
  checkoutEventBus.subscribe(
    checkoutEventBus.EVENTS.checkoutStageChanged,
    () => {
      hideGiftMessageBlock();
    }
  );
}

/**
 * Sets the shipping address view depending on
 * the selected shipping method and address option
 */
function setTheShippingAddressView() {
  const existingAddresses = $('[name="shipmentSelector"][value]').length > 1;
  const isNewAddress = $('[name="shipmentSelector"][value="new"]').prop(
    'checked'
  );
  const shippingForm = document.querySelector('.shipping-form');
  const selectedShippingMethodInput = shippingForm.querySelector(
    '.shipping-method-list input:checked'
  );

  const isSelectedMethodStoreShipping =
    selectedShippingMethodInput.dataset.pickup === 'true';
  if (isSelectedMethodStoreShipping) {
    hideAddressSelectorAndBlock($(shippingForm));
  } else if (isNewAddress) {
    showOnlyAddressBlock($(shippingForm));
  } else {
    showOnlyAddressSelector($(shippingForm));
  }

  if (isNewAddress && existingAddresses) {
    checkoutViewManager.methods.changeViewToOnlyForm();
  } else {
    checkoutViewManager.methods.changeViewToNormal();
  }
  clientSideValidation.handleSubmitState(shippingForm);
}

/**
 * Determines if the shipping form must be submitted on load
 * @param {boolean} isHomeDeliverySelected Parameter to indicate if home delivery is selected
 * @param {boolean} isStoreSelected Parameter to indicate if store delivery is selected
 * @returns {boolean} True if the shipping form must be submitted on load, else false
 */
function mustSubmitShippingOnLoad(isHomeDeliverySelected, isStoreSelected) {
  if (checkoutStageManager.methods.isStageFromShippingGroup()) {
    if (isHomeDeliverySelected) {
      const $addressSelector = $('.single-shipping .addressSelector');

      const isNewAddress =
        $addressSelector.closest('.shipping-form').attr('data-address-mode') ===
        'new';
      if (isNewAddress) {
        $('[name="shipmentSelector"][value="new"]', $addressSelector).attr(
          'checked',
          true
        );
        const checkoutMainElement = document.getElementById('checkout-main');
        if (checkoutMainElement?.dataset) {
          const { hasShipping } = checkoutMainElement.dataset;
          if (hasShipping === 'true') {
            return true;
          }
        }
      }

      const shippingAddressChecked = $(
        '[name="shipmentSelector"]:checked',
        $addressSelector
      ).val();
      const selectedAddressIsASavedOne =
        typeof shippingAddressChecked !== 'undefined' &&
        shippingAddressChecked !== 'new';
      if (selectedAddressIsASavedOne) {
        // Trigger saved address change to validate it on load
        $addressSelector.trigger('change');
        return true;
      }
    } else if (isStoreSelected) {
      // Store delivery with store selected
      return true;
    }
  }
  return false;
}

/**
 * Listens to shipping events to change checkout stage
 */
function listenShippingEventsToChangeCheckoutStage() {
  $('.shipping-method-edit').on('click', () => {
    checkoutStageManager.methods.setStage(
      checkoutStageConstants.SHIPPING_METHOD
    );
  });

  $('.shipping-address__edit').on('click', () => {
    checkoutStageManager.methods.setStage(
      checkoutStageConstants.SHIPPING_ADDRESS
    );
  });

  $('.shipping-summary__next-step').on('click', () => {
    hideElementsBySelector('.tax-info-message');
  });

  $('.checkout-breadcrumbs__element--shipping').on('click', () => {
    checkoutStageManager.methods.setStage(
      checkoutStageConstants.SHIPPING_METHOD
    );
  });
}

/**
 * Listens to shipping events to publish analytics events
 */
function listenShippingEventsToPublishAnalytics() {
  const summaryItem = ANALYTICS_EVENTS.PAYLOADS.checkoutOrderSummaryEdited.item;
  $('.shipping-method-edit').on('click', () => {
    // Send info for Analytics
    analyticsEventBus.publish(
      analyticsEventBus.EVENTS.checkoutOrderSummaryEdited,
      {
        item: summaryItem.shipping,
      }
    );
  });
}

/**
 * Checks if the selected shipping method is the online shipping method
 * @returns {boolean} True if online shipping method is selected, false otherwise
 */
function isOnlineShippingMethodSelected() {
  const checkedShippingMethodInput = document.querySelector(
    '.shipping-method-list [type="radio"]:checked'
  );
  return checkedShippingMethodInput?.value === shippingMethodsConfig.id.ONLINE;
}

module.exports = Object.assign(base, {
  listenShippingEventsToChangeCheckoutStage,
  listenShippingEventsToPublishAnalytics,
  methods: {
    ...base.methods,
    clearShippingForms,
    eventsGiftMessageSelect,
    handleBillingSelection,
    hideAddressSelectorAndBlock,
    hideGiftMessageBlock,
    isOnlineShippingMethodSelected,
    isPickupMethodSelected,
    mustSubmitShippingOnLoad,
    selectNewAddress,
    selectShippingMethodAjax,
    setTheShippingAddressView,
    shippingFormResponse,
    showOnlyAddressBlock,
    showOnlyAddressSelector,
    submitShipping,
    updateShippingAddressFormValues,
    updateShippingInformation,
    updateShippingMethodList,
    updateShippingSummaryInformation,
  },
  saveMultiShipInfo,
  selectShippingMethod,
  subscribeToEvents,
  updateShippingList,
});
